import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Container, Form, Input, Button, Title, Footer, CapsLockHint } from './styles';
import MessageModal from '../shared/MessageModal';

export default function Login({ onSwitchToRegister }) {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [capsLockOn, setCapsLockOn] = useState(false);
    const [messageModal, setMessageModal] = useState({ open: false, title: 'Aviso', message: '' });
    const passwordFocusedRef = useRef(false);
    const { login } = useAuth();

    const handlePasswordKey = (e) => {
        if (typeof e.getModifierState === 'function') {
            setCapsLockOn(e.getModifierState('CapsLock'));
        }
    };

    useEffect(() => {
        const handleCapsLockKey = (e) => {
            if (!passwordFocusedRef.current) return;
            const isCapsLockKey = e.key === 'CapsLock' || e.keyCode === 20;
            if (!isCapsLockKey) return;
            // Só no keyup: o navegador pode ainda não ter atualizado getModifierState no keydown.
            // Alternamos o estado ao soltar a tecla, assim não dependemos do timing do getModifierState.
            if (e.type === 'keyup') {
                setCapsLockOn((prev) => !prev);
            }
        };
        window.addEventListener('keydown', handleCapsLockKey, true);
        window.addEventListener('keyup', handleCapsLockKey, true);
        return () => {
            window.removeEventListener('keydown', handleCapsLockKey, true);
            window.removeEventListener('keyup', handleCapsLockKey, true);
        };
    }, []);

    async function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true);

        const result = await login(email, password);

        if (!result.success) {
            setMessageModal({
                open: true,
                title: 'Erro',
                message: result.message,
            });
        }

        setIsLoading(false);
    }

    return (
        <Container>
            {messageModal.open && (
                <MessageModal
                    title={messageModal.title}
                    message={messageModal.message}
                    onClose={() => setMessageModal((m) => ({ ...m, open: false }))}
                />
            )}
            <Title>Acesse sua conta</Title>
            <Form onSubmit={handleSubmit}>
                <Input
                    placeholder="E-mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <div>
                    <Input
                        placeholder="Senha"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handlePasswordKey}
                        onKeyUp={handlePasswordKey}
                        onFocus={() => { passwordFocusedRef.current = true; }}
                        onBlur={() => { passwordFocusedRef.current = false; }}
                        required
                    />
                    {capsLockOn && (
                        <CapsLockHint role="status">
                            Caps Lock está ativo
                        </CapsLockHint>
                    )}
                </div>
                <Button type="submit" disabled={isLoading}>
                    {isLoading ? 'Entrando...' : 'Entrar'}
                </Button>
            </Form>
            <Footer>
                Não tem uma conta?
                <button type="button" onClick={onSwitchToRegister}>
                    Cadastre-se
                </button>
            </Footer>
            <Footer>
                Esqueceu sua senha ou precisa definir senha de primeiro acesso?
                <button type="button" onClick={() => navigate('/recuperar-senha')}>
                    Recuperar senha
                </button>
            </Footer>
        </Container>
    );
}
